import React from "react";
import logoHabitia from "../../../assets/logo.png";

// PAGINA 1 — Portada del reglamento. No lleva pfooter (es full-bleed azul).
export default function CoverPage({ config }) {
  return (
    <section className="page cover">
      <div className="cover-top">
        <img src={logoHabitia} alt="habitia" />
        <div className="meta">
          <b>Reglamento Interno</b>
          <span>Aprobado · {config.fechaAprobacion}</span>
        </div>
      </div>
      <div className="h-stage" aria-hidden="true">
        <div className="h-mark">
          <div className="bar-l" />
          <div className="bar-c" />
          <div className="bar-r" />
        </div>
      </div>
      <div className="cover-copy">
        <span className="eyb">Edificios que evolucionan</span>
        <h1>
          Reglamento<br />
          Interno del<br />
          <em>Edificio.</em>
        </h1>
        <p className="lead">
          Documento aprobado en Asamblea de Copropietarios. Establece derechos, obligaciones y prohibiciones para una convivencia clara y ordenada.
        </p>
      </div>
      <div className="cover-bottom">
        <div><div className="lbl">Edificio</div><div className="val">{config.edificio}</div></div>
        <div><div className="lbl">Padrón</div><div className="val">{config.padron}</div></div>
        <div><div className="lbl">Vigencia</div><div className="val">{config.vigenciaDesde}</div></div>
        <div><div className="lbl">Versión</div><div className="val">{config.version}</div></div>
      </div>
    </section>
  );
}
